export const EXCLUDED_APPLICATION_COLUMNS = [
    'businessOwnerId', 'portfolioId', 'serverIds'
];

export const EXCLUDED_SERVER_COLUMNS = [
    'applicationMappings',
    'ec2RecommendationOverrideAvgUtilization',
    'ec2RecommendationOverrideOnPremCapacity',
    'ec2RecommendationOverridePeakUtilization',   
    'migrationPlan',
    'migrationPlanOverride', 
    'portfolioId',
    'serverSupportId',
];

export const EXCLUDED_DATABASE_COLUMNS = [
    'dbOwnerId', 'portfolioId'
];

export const MAX_NAME_CHARACTERS = 255;
